(ns io.daskul.tutorial.webapp.shared.log
  "Logging utilities using Timbre."
  (:require
   [taoensso.timbre :as timbre]))

(defn init!
  "Initialize logging configuration. Call at app startup."
  []
  (timbre/merge-config!
   {:level :debug
    :appenders {:console (timbre/console-appender)}}))

(defn debug
  ([msg] (timbre/debug msg))
  ([msg context] (timbre/debug msg context)))

(defn info
  ([msg] (timbre/info msg))
  ([msg context] (timbre/info msg context)))

(defn warn
  ([msg] (timbre/warn msg))
  ([msg context] (timbre/warn msg context)))

(defn error
  ([msg] (timbre/error msg))
  ([msg context] (timbre/error msg context)))
